var map = {
	"./01.Lotame.png": 438,
	"./02.TA-formerly-TO_F.png": 798,
	"./03.TheTradeDesk.png": 1430,
	"./04.Liveramp-correct-logo-300-x-119-px.png": 8226,
	"./05.Neustar.png": 8232,
	"./06.App-Nexus.png": 8852,
	"./07.Adobe-1024x267.png": 3668,
	"./08.Oracle.png": 9167,
	"./09.Eyeota.jpg": 1957,
	"./10.Pushspring-.png": 846,
	"./11.Snapchat-1024x576.jpg": 787,
	"./12.Instagram-1-1024x576.png": 2710,
	"./13.Facebook-1-1024x576.png": 4137
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1173;